module.exports = __webpack_public_path__ + "img/default-avtar.f5764a73.png";